import * as R from 'ramda';
import gql from 'graphql-tag';
import gqlClient from 'js/graphql/client/gqlClient';
import logoutUser from 'js/graphql/logout';

export const queryMoodBoard = async campaignIds => {
    try {
        const filter = {
            or: campaignIds.map(id => ({
                field: 'id',
                operator: '=',
                value: `${id}`
            }))
        };

        if (gqlClient.client === undefined) {
            await gqlClient.createClient();
        }

        if (gqlClient.client === undefined) {
            throw new Error('Unable to create client');
        }

        const result = await gqlClient.client.query({
            query: gql`
                query CampaignMoodBoards($filter: Filter!) {
                    campaigns(orderDir: "desc", filter: $filter) {
                        edges {
                            node {
                                id
                                productions {
                                    edges {
                                        node {
                                            moodBoard {
                                                edges {
                                                    node {
                                                        filestackHandle
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables: {filter}
        });

        const moodBoardContent = result.data.campaigns.edges;

        if (moodBoardContent) {
            return moodBoardContent
                .map(moodBoardCampaign => {
                    const hasProductionEdges = moodBoardCampaign.node.productions.edges.length > 0;
                    if (!hasProductionEdges) return null;

                    const moodBoardEdges = R.path(
                        ['node', 'productions', 'edges', 0, 'node', 'moodBoard', 'edges'],
                        moodBoardCampaign
                    );

                    const hasMoodBoardEdges = moodBoardEdges.length > 0;
                    if (!hasMoodBoardEdges) return null;

                    const moodBoardImagesArray = moodBoardEdges.map(
                        moodBoard =>
                            `https://cdn.filestackcontent.com/${moodBoard.node.filestackHandle}`
                    );

                    return {
                        id: moodBoardCampaign.node.id,
                        images: moodBoardImagesArray
                    };
                })
                .filter(campaign => !!campaign);
        }
    } catch (error) {
        if (error.message.includes('401')) {
            return logoutUser();
        }

        throw error;
    }
    return [];
};



// WEBPACK FOOTER //
// ./graphql/queries/queryMoodBoard.js